// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(staffNo?: string, options?: { [key: string]: any }) {
  const devStaffNo = staffNo ?? (typeof window !== 'undefined' ? localStorage.getItem('devStaffNo') || 'Asia-ext-weiy@tuv.group' : 'Asia-ext-weiy@tuv.group');
  return request<{ data: API.CurrentUser }>('/app/oauth2/v1/login', {
    method: 'GET',
    params: { staffNo: devStaffNo },
    ...(options || {}),
  });
}

export async function queryCurrentUser(options?: { [key: string]: any }) {
  return currentUser(undefined, options);
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/login/outLogin', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 登录接口 POST /app/auth/v1/login */
export async function login(body: { account: string; password: string }, options?: { [key: string]: any }) {
  return request<any>('/app/auth/v1/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
/** 审核历史分页查询 GET /app/video/v1/log/page */
export async function queryVideoAuditHistoryPage(
  params: {
    // query
    videoId: string;
    current: number;
    size: number;
  },
  options?: { [key: string]: any },
) {
  return request<any>('/app/video/v1/log/page', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 视频知识点标签分页查询 GET /app/video/v1/split/segment/page */
export async function queryVideoSplitSegmentPage(
  params: {
    // query
    videoId: string;
    current: number;
    size: number;
  },
  options?: { [key: string]: any },
) {
  return request<any>('/app/video/v1/split/segment/page', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 添加视频知识点标签 POST /app/video/v1/add/split/segment */
export async function addVideoSplitSegment(
  data: {
    // body
    videoId: string;
    startTime: number;
    endTime: number;
    tagJson: Array<{ id: string; name: string }>;
  },
  options?: { [key: string]: any },
) {
  return request<any>('/app/video/v1/add/split/segment', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 修改视频知识点标签 POST /app/video/v1/update/split/segment */
export async function updateVideoSplitSegment(
  data: {
    // body
    id: string;
    videoId: string;
    startTime?: number;
    endTime?: number;
    tagJson?: Array<{ id: string; name: string }>;
  },
  options?: { [key: string]: any },
) {
  return request<any>('/app/video/v1/update/split/segment', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 删除视频知识点标签 DELETE /app/video/v1/delete/split/segment */
export async function deleteVideoSplitSegment(
  data: {
    // body
    id: string;
  },
  options?: { [key: string]: any },
) {
  return request<any>('/app/video/v1/delete/split/segment', {
    method: 'DELETE',
    data,
    ...(options || {}),
  });
}

/** 添加帧图片与OCR内容 POST /app/video/v1/add/frame/image */
export async function addVideoFrameImage(
  data: {
    // body
    videoId: string;
    frameTime: number;
  },
  options?: { [key: string]: any },
) {
  return request<any>('/app/video/v1/add/frame/image', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 修改帧图片与OCR内容 PUT /app/video/v1/update/frame/image */
export async function updateVideoFrameImage(
  data: {
    // body
    id: string;
    videoId: string;
    content?: string;
    tagJson?: Array<{ id: string; name: string }>;
  },
  options?: { [key: string]: any },
) {
  return request<any>('/app/video/v1/update/frame/image', {
    method: 'PUT',
    data,
    ...(options || {}),
  });
}

/** 删除帧图片与OCR内容 DELETE /app/video/v1/delete/frame/image */
export async function deleteVideoFrameImage(
  data: {
    // body
    id: string;
  },
  options?: { [key: string]: any },
) {
  return request<any>('/app/video/v1/delete/frame/image', {
    method: 'DELETE',
    data,
    ...(options || {}),
  });
}

/** 帧图片 OCR 重试 POST /app/video/v1/retry/frame/image/ocr */
export async function retryFrameImageOcr(
  data: {
    // body
    id: string;
  },
  options?: { [key: string]: any },
) {
  return request<any>('/app/video/v1/retry/frame/image/ocr', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 删除视频 DELETE /app/video/v1/delete */
export async function deleteVideo(
  data: {
    // body
    id: string;
  },
  options?: { [key: string]: any },
) {
  return request<any>('/app/video/v1/delete', {
    method: 'DELETE',
    data,
    ...(options || {}),
  });
}

/** 重试视频解析 POST /app/video/v1/retry */
export async function retryVideo(
  data: {
    // body
    id: string;
  },
  options?: { [key: string]: any },
) {
  return request<any>('/app/video/v1/retry', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 拆条视频 GET /app/video/v1/split/video */
export async function videoSplitVideo(
  params: {
    id: string;
  },
  options?: { [key: string]: any },
) {
  return request<any>('/app/video/v1/split/video', {
    method: 'GET',
    params,
    ...(options || {}),
    timeout: 600000, // 10分钟超时
  });
}

/** 帧图片与OCR内容分页查询 GET /app/video/v1/frame/image/page */
export async function queryVideoFrameImagePage(
  params: {
    // query
    videoId: string;
    current: number;
    size: number;
  },
  options?: { [key: string]: any },
) {
  return request<any>('/app/video/v1/frame/image/page', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 帧图片与OCR内容详情查询 GET /app/video/v1/frame/image/detail */
export async function queryVideoFrameImageDetail(
  params: {
    // query
    id: string;
  },
  options?: { [key: string]: any },
) {
  return request<any>('/app/video/v1/frame/image/detail', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 语音识别文本分页查询 GET /app/video/v1/asr/text/page */
export async function queryVideoAsrTextPage(
  params: {
    // query
    videoId: string;
    current: number;
    size: number;
  },
  options?: { [key: string]: any },
) {
  return request<any>('/app/video/v1/asr/text/page', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 修改语音识别文本 PUT /app/video/v1/update/asr/text */
export async function updateVideoAsrText(
  data: {
    // body
    id: string;
    videoId: string;
    content: string;
  },
  options?: { [key: string]: any },
) {
  return request<any>('/app/video/v1/update/asr/text', {
    method: 'PUT',
    data,
    ...(options || {}),
  });
}

/** 完成审核 POST /app/video/v1/complete/audit */
export async function completeAudit(
  data: {
    // body
    id: string;
  },
  options?: { [key: string]: any },
) {
  return request<any>('/app/video/v1/complete/audit', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 确认开启审核 POST /app/video/v1/confirm/start/audit */
export async function confirmStartAudit(
  data: {
    // body
    id: string;
  },
  options?: { [key: string]: any },
) {
  return request<any>('/app/video/v1/confirm/start/audit', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 登录用户信息接口响应 */
export interface ProfileRes {
  data: {
    id: number;
    staffNameEn: string;
    staffNameCn: string;
    staffNo: string;
    email?: string;
    account?: string;
    roleNames?: Record<string, unknown>[];
  };
}

/** 登录用户-用户基本信息 */
export function profile(): Promise<ProfileRes> {
  return request<ProfileRes>('/app/user/v1/profile', {
    method: 'GET',
  });
}

export interface LogoutRes {}

export function logout(): Promise<LogoutRes> {
  return request<LogoutRes>('/app/auth/v1/logout', {
    method: 'GET',
  });
}

export interface Page_9Res {
  current: number;
  size: number;
  records: {
    id: number;
    messageType: number;
    title: string;
    content: string;
    fromUserId: number;
    fromUserName: string;
    createTime: Record<string, unknown> | string;
  }[];
  total: number;
  pages: number;
}

export function page_9(
  fromUserName: string,
  content: string,
  startCreateTime: string,
  endCreateTime: string,
  current: number,
  size: number,
): Promise<Page_9Res> {
  return request<Page_9Res>('/app/message/v1/page', {
    method: 'GET',
    params: { fromUserName, content, startCreateTime, endCreateTime, current, size },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}

export async function getConfig(options: {
  fileName: string;
  action: string;
  type: string;
  [key: string]: any; // 允许其他可选字段
}) {
  return request<API.CommonResponse<API.DocumentConfig>>('/app/document/v1/config', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function getRefreshConfig(options: {
  targetFileId: number;
  targetFileType: string;
  permissions: string;
}) {
  return request('/app/document/v1/refresh/config', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function getFileHistory(params: {
  targetFileId: number | string;
  targetFileType: string;
}) {
  console.log('params', params);
  return request<API.CommonResponse<API.IHistory>>('/app/document/v1/history/list', {
    method: 'GET',
    params: {
      ...params,
    },
  });
}

export async function getHistoryData(params: {
  targetFileId: number | string;
  targetFileType: string;
  version: string;
}) {
  console.log('params', params);
  return request<API.CommonResponse<API.IFileChange>>('/app/document/v1/history/data', {
    method: 'GET',
    params: {
      ...params,
    },
  });
}

export async function putFileRestore(body: {
  targetFileId: number | string;
  targetFileType: string;
  version: string;
  url: string;
}) {
  console.log('body', body);
  return request('/app/document/v1/restore', {
    method: 'PUT',
    data: body,
  });
}

export async function getSuggestParaIdList(params: { templateFileId: string; paraId: string }) {
  console.log('params', params);
  return request(`/app/template/placeHolder/suggest/${params.paraId}/${params.templateFileId}`, {
    method: 'GET',
    params: {
      ...params,
    },
  });
}

export async function addParaId(body: {
  paraId: string;
  placeHolder: string;
  templateFileId: string;
}) {
  console.log('body', body);
  return request('/app/template/paraid/add', {
    method: 'POST',
    data: body,
  });
}

export async function updateParaId(body: {
  paraId: string;
  placeHolder: string;
  templateFileId: string;
}) {
  console.log('body', body);
  return request('/app/template/placeHolder/update', {
    method: 'POST',
    data: body,
  });
}

export async function addPlaceHolder(body: {
  templateFileId: string;
  paraId: string;
  placeHolder: string;
}) {
  console.log('body', body);
  return request('/app/template/placeHolder/add', {
    method: 'POST',
    data: body,
  });
}

export async function deletePlaceHolder(body: { id: string }) {
  console.log('body', body);
  return request('/app/template/placeHolder/delete', {
    method: 'POST',
    data: body,
  });
}

export async function getPermissionTree(options?: { [key: string]: any }) {
  return request('/app/menu/v1/permission/tree', {
    method: 'GET',
    ...(options || {}),
  });
}

export interface MessageUnreadCountVO {
  data: {
    count: number;
  };
}

/** 消息未读数量 */
export function getMessageUnreadCount(): Promise<MessageUnreadCountVO> {
  return request<MessageUnreadCountVO>('/app/message/v1/unread/count', {
    method: 'GET',
  });
}

/** 全部标注已读 */
export function markAllMessagesAsRead(): Promise<void> {
  return request('/app/message/v1/mark/all/read', {
    method: 'PUT',
  });
}



// Response interface
export interface Delete_12Res {}

/**
 * 删除消息
 * @param {string} id 主键id
  * @returns
 */
export async function delete_12(id: string) {
  return request<Delete_12Res>('/app/message/v1/delete', {
    method: 'DELETE',
    params: {
      id,
    },
  });
}

// Response interface
export interface Detail_1Res {
  data: {
    /*主键id */
    id: number;

    /*消息类型;0审核通过 1审核退回 2审核提醒 3检查提醒 5检查完成 */
    messageType: number;

    /*消息标题 */
    title: string;

    /*消息内容 */
    content: string;

    /*扩展json-业务数据 */
    extensionJson: string;

    /*发送用户id */
    fromUserId: number;

    /*发送用户名称 */
    fromUserName: string;

    /*接收用户id */
    toUserId: number;

    /*是否已读;0否 1是 */
    readFlag: number;

    /*已读时间 */
    readTime: Record<string, unknown>;

    /*创建时间 */
    createTime: Record<string, unknown>;
  }
}

/**
 * 消息详情
 * @param {string} id
  * @returns
 */
export async function detail_1(id: string) {
  return request<Detail_1Res>('/app/message/v1/detail', {
    method: 'GET',
    params: {
      id,
    },
  });
}

/** 首次修改密码接口 PUT /app/user/v1/first/update/password */
export async function firstUpdatePassword(body: { password: string }, options?: { [key: string]: any }) {
  return request<any>('/app/user/v1/first/update/password', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 修改密码接口 PUT /app/user/v1/update/password */
export async function updatePassword(body: { oldPassword: string; password: string }, options?: { [key: string]: any }) {
  return request<any>('/app/user/v1/update/password', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 分页查询消息接口 GET /app/message/v1/page */
export async function queryMessagePage(current: number, size: number, options?: { [key: string]: any }) {
  return request<any>('/app/message/v1/page', {
    method: 'GET',
    params: {
      current,
      size,
    },
    ...(options || {}),
  });
}

/** 标记消息为已读接口 DELETE /app/message/v1/mark/read */
export async function markMessageAsRead(id: string, options?: { [key: string]: any }) {
  return request<any>('/app/message/v1/mark/read', {
    method: 'DELETE',
    params: {
      id,
    },
    ...(options || {}),
  });
}

export interface VideoPageRes {
  data: {
    records: VideoPageV0[];
    total: number;
  }
}
export interface VideoPageV0 {
    id: string;
    title: string;
    duration: number;
    gradeName: string;
    subjectName: string;
    status: number;
    tags: string[];
}

/** 视频分页列表接口 GET /app/video/v1/page */
export async function queryVideoPage(params: {
  gradeName?: string;
  subjectName?: string;
  name?: string;
  status?: number;
  statusList?: string;
  current: number;
  size: number;
}, options?: { [key: string]: any }) {
  return request<VideoPageRes>('/app/video/v1/page', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 视频年级学科列表接口 GET /app/video/v1/grade/subject/list */
export async function queryVideoGradeSubjectList(options?: { [key: string]: any }) {
  return request<any>('/app/video/v1/grade/subject/list', {
    method: 'GET',
    ...(options || {}),
  });
}

/** OAuth2客户端令牌接口 POST /app/oauth2/v1/client/token */
export async function getOAuth2ClientToken(options?: { [key: string]: any }) {
  return request<any>('/app/oauth2/v1/client/token', {
    method: 'POST',
    data: {
      clientId: process.env.OAUTH_CLIENT_ID,
      clientSecret: process.env.OAUTH_CLIENT_SECRET,
      grantType: 'client_credentials',
      scope: 'chatStream,sessionPage,historyPage,recommend',
    },
    ...(options || {}),
  });
}

/** 获取视频详情接口 GET /app/video/v1/detail */
export async function getVideoDetail(id: string, options?: { [key: string]: any }) {
  return request<any>('/app/video/v1/detail', {
    method: 'GET',
    params: {
      id,
    },
    ...(options || {}),
  });
}

/** 添加视频 POST /app/video/v1/add */
export async function addVideo(
  data: {
    // body
    name: string;
    refVideoId: number;
    refVideoType: number;
    refVideoSrc: string;
    grade: string;
    subject: string;
    exerciseId?: string;
    videoSize?: number;
    videoDuration?: number;
    description?: string;
  },
  options?: { [key: string]: any },
) {
  return request<any>('/app/video/v1/add', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 获取标签树接口 GET /app/label/v1/tree */
export async function getLabelTree(gradeName?: string, subjectName?: string, keyword?: string, treeSetId?: string, options?: { [key: string]: any }) {
  return request<any>('/app/label/v1/tree', {
    method: 'GET',
    params: {
      gradeName,
      subjectName,
      keyword,
      treeSetId,
    },
    ...(options || {}),
  });
}

/** 内容打标签接口 GET /app/label/v1/marker */
export async function retrieveLabelTree(targetId?: number | string, videoId?: number | string, tagType?: number, content?: string, options?: { [key: string]: any }) {
  return request<any>('/app/label/v1/marker', {
    method: 'GET',
    params: {
      targetId: targetId ? targetId : '',
      videoId: videoId ? videoId: '',
      tagType,
      content,
    },
    ...(options || {}),
    timeout: 600000, // 10分钟超时
  });
}

/** 标签详情接口 GET /app/label/v1/detail */
export async function getLabelDetail(id: string, options?: { [key: string]: any }) {
  return request<any>('/app/label/v1/detail', {
    method: 'GET',
    params: {
      id,
    },
    ...(options || {}),
  });
}

/** 知识库关联视频分页列表接口 GET /app/video/v1/knowledge/page */
export async function getKnowledgeVideoPage(params: {
  tagId: string;
  current: number;
  size: number;
}, options?: { [key: string]: any }) {
  return request<any>('/app/video/v1/knowledge/page', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 查看视频详情权限 GET /app/video/v1/view/permission */
export async function getVideoViewPermission(id: number, options?: { [key: string]: any }) {
  return request<any>('/app/video/v1/view/permission', {
    method: 'GET',
    params: {
      id,
    },
    ...(options || {}),
  });
}

/** 知识库关联习题分页列表接口 GET /app/question/bank/v1/page */
 export async function getQuestionBankPage(params: {
   tagId: string;
   current: number;
   size: number;
 }, options?: { [key: string]: any }) {
   return request<any>('/app/question/bank/v1/page', {
     method: 'GET',
     params: {
       ...params,
     },
     ...(options || {}),
   });
 }

 /** 知识库关联习题详情接口 GET /app/question/bank/v1/detail */
 export async function getQuestionBankDetail(exerciseId: string, options?: { [key: string]: any }) {
   return request<any>('/app/question/bank/v1/detail', {
     method: 'GET',
     params: {
       exerciseId,
     },
     ...(options || {}),
   });
 }

/** 知识库关联习题视频URL接口 GET /app/question/bank/v1/videoUrl */
export async function getQuestionBankVideoUrl(exerciseId: string, options?: { [key: string]: any }) {
  return request<any>('/app/question/bank/v1/videoUrl', {
    method: 'GET',
    params: {
      exerciseId,
    },
    ...(options || {}),
  });
 }

/** 知识库列表接口 GET /app/knowledge/v1/page */
export async function getKnowledgeList(params: {
  name?: string;
  gradeName?: string;
  subjectName?: string;
  current: number;
  size: number;
}, options?: { [key: string]: any }) {
  return request<any>('/app/knowledge/v1/page', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取知识库详情接口 GET /app/knowledge/v1/{id} */
export async function getKnowledgeDetail(id: string, options?: { [key: string]: any }) {
  return request<any>(`/app/knowledge/v1/${id}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取知识点详情接口 GET /app/knowledge/v1/tag/{tagId} */
export async function getKnowledgeTagDetail(tagId: string, options?: { [key: string]: any }) {
  return request<any>(`/app/knowledge/v1/tag/${tagId}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** AI聊天SSE流式接口 POST /app/chat/v1/stream */
export async function chatStream(
  params: {
    question: string;
    gradeName: string;
    subjectName: string;
    sessionId?: string;
    newSession?: boolean;
  },
  files?: string[],
  options?: { [key: string]: any }
): Promise<ReadableStream<Uint8Array>> {
  const url = '/app/chat/v1/stream';

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      arg0: params,
      files: files || [],
    }),
    credentials: 'include',
    ...(options || {}),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.body as unknown as ReadableStream<Uint8Array>;
}

/** 推荐题目/视频 GET /app/chat/v1/recommend */
export async function chatRecommend(
  params: {
    historyId?: string;
    exerciseId?: number;
    tagIds?: (number | string)[];
    difficulty?: string;
    gradeName?: string;
    subjectName?: string;
  },
  options?: { [key: string]: any }
) {
  const accessToken =
    typeof window !== 'undefined' ? localStorage.getItem('chatAccessToken') : '';
  return request<{
    success?: boolean;
    data?: API.ChatRecommendResult;
  }>('/app/chat/v1/recommend', {
    method: 'GET',
    params: {
      ...params,
      tagIds: params.tagIds?.join(','),
    },
    headers: accessToken
      ? { Authorization: `Bearer ${accessToken}` }
      : undefined,
    timeout: options?.timeout ?? 120000,
    ...(options || {}),
  });
}
